import React, { useState, useEffect, useRef } from 'react';

import { BitacoraService } from '../../services/Bitacora/BitacoraService';

import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { Toolbar } from 'primereact/toolbar';

import { useLocalState } from '../../util/useLocalStorage';
import { FilterMatchMode } from 'primereact/api';
import { UsuarioService } from '../../services/Usuario/UsuarioService';
import { ConfiguracionService } from '../../services/Configuracion/ConfiguracionService';

const Supervisor = () => {
    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");
    /**Headers Token */
    const config = {
        headers: {
            'Content-Type': "application/json",
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: `Bearer ${jwt}`
        }
    }

    let _bitacoraDet = {

        bitacoraDetId: 0,
        activo: true,
        booking: '',
        cablePlug: '',
        conductorCedula: '',
        conductorNombre: '',
        contenedor: '',
        destinoCodigo: '',
        destinoNombre: '',
        displey: '',
        dispositivoFechaReporte: '',
        dispositivoIdentificador: '',
        dispositivoNombre: '',
        dispositivoUbicacionLat: '',
        dispositivoUbicacionLon: '',
        estado: '',
        fechaBitacora: '',
        fechaIngreso: '',
        micro: '',
        observacion: '',
        precintoSeguridad: '',
        vehiculoChasis: '',
        vehiculoPlaca: '',
        empresaTransporte: {

        },
        dispositivo: {
            tipoDispositivo: {}

        },
        bitacoraCab: {
            "bitacoraCabId": 0,
            "activo": '',
            "estado": '',
            "fecha": '',
            turno: {

            },
            usuario: {

            },
            "bitacoradets": null
        }

    }

    const usuarioService = new UsuarioService();
    const configuracionService = new ConfiguracionService();

    const toast = useRef(null);
    const dt = useRef(null);

    const bitacoraService = new BitacoraService();
    const [bitacoraDet, setBitacoraDet] = useState(_bitacoraDet);

    /**Usuario */
    const [usuario, setUsuario] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const [fecha, setFecha] = useState("");
    const [listaTurno, setListaTurno] = useState(null);
    const [turno, setTurno] = useState([]);
    const [contenedorDialog, setContenedorDialog] = useState("");

    /**Habilitar Botón de Agregar y Buscar */
    const [habilitarBoton, setHabilitarBoton] = useState("");

    /**Habilitar Campos Fecha y Jornada */
    const [habilitarCampo, setHabilitarCampo] = useState("");

    const [username, setUsername] = useLocalState("", "username");
    const [roles, setRoles] = useState([]);
    const [contenedores, setContenedores] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [color, setColor] = useState("red");


    useEffect(() => { setHabilitarBoton(true) }, []);
    useEffect(() => { setColor("red") }, []);
    useEffect(() => { setHabilitarCampo(false) }, []);
    useEffect(() => {
        usuarioService.getUsuario(username)
            .then(data => setUsuario(data))
            .then(setRoles(usuario.roles));
    }, []);
    useEffect(() => { configuracionService.getTurno().then(data => setListaTurno(data)); }, []);

    const showFail = (message) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
    }

    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: 'Success Message', detail: message, life: 3000 });
    }

    const limpiar = () => {
        setFecha("");
        setTurno("");
        setHabilitarBoton(true);
        setHabilitarCampo(false);
        setContenedores("");
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-book" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
            </React.Fragment>
        );
    }

    const onChangeFecha = (e) => {
        setFecha(e.value);
        if (turno.length !== 0)
            setHabilitarBoton(false);
        else
            setHabilitarBoton(true);
    }

    const onChangeTurno = (e) => {
        setTurno(e.value);
        if (fecha !== null && fecha !== "")
            setHabilitarBoton(false);
        else
            setHabilitarBoton(true);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const buscarContenedoresPorUsuarioyFecha = () => {
        setHabilitarCampo(true);
        let _fecha = formatearFecha(fecha);
        setRoles(usuario.roles);

        bitacoraService.consultarPorFechaYTurno(_fecha, turno.configuracionDetId).then(data => {
            if (data.mensaje.codigo.includes('ERR')) {
                showFail(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
            } else {
                let _datos = [];
                data.data.forEach(_bitacoraCab => {
                    _bitacoraCab.bitacoradets.forEach(_bitacoraDet => {
                        _datos.push(_bitacoraDet);
                    });
                });
                setContenedores(_datos);
                console.log(_datos);
                showSuccess(data.mensaje.codigo + ' - ' + data.mensaje.mensaje);
            }
        })
    }

    const formatearFecha = (fecha, formato = 'dd-mm-yyyy') => {

        let d = new Date(fecha),
            month = ("0" + (d.getMonth() + 1)).slice(-2),
            day = ("0" + d.getDate()).slice(-2),
            year = d.getFullYear(),
            hour = ("0" + d.getHours()).slice(-2),
            minutes = ("0" + d.getMinutes()).slice(-2),
            seconds = ("0" + d.getSeconds()).slice(-2);

        switch (formato) {

            case 'dd-mm-yyyy':
                return [day, month, year].join('-');

            case 'yyyy-mm-dd hh:mm:ss':
                return [year, month, day].join('-').concat(' ').concat([hour, minutes, seconds].join(':'));

            default:
                return [year, month, day].join('-');

        }
    }


    const header = (
        <div className="table-header">
            <h5 className="mx-0 my-1">Lista de Bitacoras</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} type="search" onInput={onGlobalFilterChange} placeholder="Buscar Bitacora" />
            </span>
        </div>
    );



    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _bitacoraDet = { ...bitacoraDet };
        _bitacoraDet[`${name}`] = val;
        setBitacoraDet(_bitacoraDet);
    }

    const editProduct = (bitacoraDet) => {
        setBitacoraDet({ ...bitacoraDet });
        setContenedorDialog(true);
    }

    const hideDialog = () => {
        setBitacoraDet(_bitacoraDet);
        setSubmitted(false);
        setContenedorDialog(false);
    }

    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        </React.Fragment>
    );

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const rightToolbarTemplate = () => {
        return <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />;
    };


    return (
        <>
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card p-fluid">
                    <h5>Control de Contenedores</h5>
                    <div className="formgrid grid">
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="icon">Fecha</label>
                            <Calendar id="icon" value={fecha} disabled={habilitarCampo} onChange={onChangeFecha} showIcon dateFormat="dd/mm/yy" />
                        </div>
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="turno">Turno</label>
                            <Dropdown id="turno" value={turno} optionLabel="nombre" disabled={habilitarCampo} options={listaTurno} onChange={onChangeTurno} placeholder="Seleccionar"></Dropdown>
                        </div>
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="buscar">&nbsp;</label>
                            <Button id="buscar" label="Buscar" disabled={habilitarBoton} onClick={buscarContenedoresPorUsuarioyFecha} className="p-button-success p-button-raised   " icon="pi pi-search" iconPos="right" />
                        </div>
                        <div className="field col-6 md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="limpiar">&nbsp;</label>
                            <Button id="limpiar" label="Limpiar" className="p-button-help p-button-raised" icon="pi pi-replay" iconPos="right" onClick={limpiar} />
                        </div>
                    </div>
                </div>

                <div className="card">
                    <Toolbar className="mb-4" right={rightToolbarTemplate}></Toolbar>
                    <DataTable ref={dt} value={contenedores}
                        dataKey="bitacoraDetId" filters={filters}
                        filterDisplay="row" globalFilterFields={['bitacoraCab.usuario.nombre', 'booking', 'conductorNombre', 'vehiculoPlaca', 'destinoNombre']}
                        header={header} responsiveLayout="scroll"
                        sortField="fechaIngreso" sortOrder={-1}>
                        <Column field="fechaIngreso" sortable header="Fecha Ingreso" style={{ minWidth: '12rem' }}></Column>
                        <Column field="bitacoraCab.usuario.nombre" header="Usuario" style={{ minWidth: '12rem' }}></Column>
                        <Column field="booking" header="Booking" style={{ minWidth: '12rem' }}></Column>
                        <Column field="contenedor" header="Contenedor" style={{ minWidth: '12rem' }}></Column>
                        <Column field="destinoCodigo" header="Destino" style={{ minWidth: '12rem' }}></Column>
                        <Column field="vehiculoPlaca" header="Placa del Vehiculo" style={{ minWidth: '12rem' }}></Column>
                        <Column field="dispositivo.nombre" header="Dispositivo" style={{ minWidth: '12rem' }}></Column>
                        <Column field="empresaTransporte.nombre" header="Empresa Transporte" style={{ minWidth: '12rem' }}></Column>
                        <Column field="conductorNombre" header="Nombre Conductor" style={{ minWidth: '12rem' }}></Column>
                        <Column field="observacion" header="Observacion" style={{ minWidth: '12rem' }}></Column>
                        <Column field="destinoNombre" header="Destino" style={{ minWidth: '12rem' }}></Column>
                        <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                    </DataTable>
                </div>
            </div>

            <Dialog visible={contenedorDialog} style={{ width: '90vw' }} header="Detalles del Contenedor" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                <div className="col-12">
                    <div className="card p-fluid">
                        <div className="field ">
                            <label htmlFor="fechaYHoraBitacora">Fecha y Hora de la Bitacora</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="fechaBitacora" id="fechaYHoraBitacora" value={bitacoraDet.fechaBitacora} onChange={(e) => onInputChange(e, 'fechaBitacora')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.fechaBitacora })} />
                        </div>
                        <div className="field">
                            <label htmlFor="booking">Booking</label>
                            <InputText type="text" disabled="booking" style={{ opacity: 1 }} id="booking" value={bitacoraDet.booking} onChange={(e) => onInputChange(e, 'booking')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="cableyPlug">CableyPlug</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="cableyPlug" id="cableyPlug" value={bitacoraDet.cablePlug} onChange={(e) => onInputChange(e, 'cablePlug')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="cedulaConductor">Cédula</label>
                            <InputText id="cedulaConductor" disabled style={{ opacity: 1 }} value={bitacoraDet.conductorCedula} onChange={(e) => onInputChange(e, 'conductorCedula')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.conductorCedula })} />
                        </div>
                        <div className="field">
                            <label htmlFor="nombreConductor">Nombre</label>
                            <InputText id="nombreConductor" disabled style={{ opacity: 1 }} type="text" value={bitacoraDet.conductorNombre} onChange={(e) => onInputChange(e, 'conductorNombre')} required className={classNames({ 'p-invalid': submitted && !bitacoraDet.conductorNombre })} />
                        </div>
                        <div className="field">
                            <label htmlFor="contenedor">Contenedor</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="contenedor" id="booking" value={bitacoraDet.contenedor} onChange={(e) => onInputChange(e, 'contenedor')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="destinoCodigo">Destino Codigo</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="destinoCodigo" id="booking" value={bitacoraDet.destinoCodigo} onChange={(e) => onInputChange(e, 'destinoCodigo')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="destinoNombre">Destino Nombre</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="destinoNombre" id="booking" value={bitacoraDet.destinoNombre} onChange={(e) => onInputChange(e, 'destinoNombre')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="displey">Destino Nombre</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="displey" id="displey" value={bitacoraDet.displey} onChange={(e) => onInputChange(e, 'displey')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="dispositivoNombre">Dispositivo</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="dispositivoNombre" id="dispositivoNombre" value={bitacoraDet.dispositivoNombre} onChange={(e) => onInputChange(e, 'dispositivoNombre')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="precintoSeguridad">Precinto Seguridad</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="precintoSeguridad" id="precintoSeguridad" value={bitacoraDet.precintoSeguridad} onChange={(e) => onInputChange(e, 'precintoSeguridad')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="observacion">Observación</label>
                            <InputText type="text" disabled style={{ opacity: 1 }} name="observacion" id="observacion" value={bitacoraDet.observacion} onChange={(e) => onInputChange(e, 'observacion')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="placa">Placa</label>
                            <InputText id="placa" disabled style={{ opacity: 1 }} name='vehiculoPlaca' value={bitacoraDet.vehiculoPlaca} onChange={(e) => onInputChange(e, 'vehiculoPlaca')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="chasis">Chasis</label>
                            <InputText id="chasis" disabled style={{ opacity: 1 }} value={bitacoraDet.vehiculoChasis} onChange={(e) => onInputChange(e, 'vehiculoChasis')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="finca">Finca</label>
                            <InputText id="finca" disabled style={{ opacity: 1 }} value={bitacoraDet.destinoNombre} onChange={(e) => onInputChange(e, 'destinoNombre')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="empresaTranporte">Empresa Transporte</label>
                            <InputText id="empresaTranporte" disabled style={{ opacity: 1 }} value={bitacoraDet.empresaTransporte.nombre} onChange={(e) => onInputChange(e, 'empresaTranporte')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="dispositivoNombre">Dispositivo</label>
                            <InputText id="dispositivoNombre" disabled style={{ opacity: 1 }} value={bitacoraDet.dispositivo.nombre} onChange={(e) => onInputChange(e, 'dispositivo')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="tipodispositivoNombre">Tipo Dispositivo</label>
                            <InputText id="tipodispositivoNombre" disabled style={{ opacity: 1 }} value={bitacoraDet.dispositivo.tipoDispositivo.nombre} onChange={(e) => onInputChange(e, 'tipoDispositivo')} required />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default Supervisor;